import React, { createContext, useContext } from 'react';

// LeagueContext provides the current league object to descendants.
// Mounted only at league-scoped routes (e.g., /leagues/:leagueId/...).
// Global routes do NOT mount this provider — useLeague() returns null
// there, matching the backend's `get_stats_season(league_info) if
// league_info else get_current_season()` pattern.
const LeagueContext = createContext(null);

export const LeagueProvider = ({ league, children }) => (
  <LeagueContext.Provider value={league ?? null}>
    {children}
  </LeagueContext.Provider>
);

// Returns the current league object, or null if used outside a
// LeagueProvider (i.e., on a truly global route). Consumers MUST
// handle the null case — use:
//
//     const league = useLeague();
//     const currentSeason = league?.current_season ?? getCurrentSeason();
//
// Per Bible Rule 6: if a league exists, its current_season is the
// source of truth. Only fall back to getCurrentSeason() when there
// is no league context at all.
export const useLeague = () => useContext(LeagueContext);
